// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"807":"f98519b2d5e63ffa21b2","980":"ea9973933a7a8906ed57"}[chunkId] + ".js";
};